const LiveList = () => import(/* webpackPrefetch: true, webpackChunkName: 'matches' */ 'wap/views/live-list/App.vue')
const MatchList = () => import(/* webpackPrefetch: true, webpackChunkName: 'matches' */ 'wap/views/match-list/App.vue')
const MatchDetail = () => import(/* webpackPrefetch: true, webpackChunkName: 'match-detail' */ 'wap/views/details/App.vue')
const ResultDetail = () => import(/* webpackPrefetch: true, webpackChunkName: 'match-detail' */ 'wap/views/result/App.vue')
const Sports = () => import(/* webpackPrefetch: true, webpackChunkName: 'matches' */ 'wap/views/sports/App.vue')
const Search = () => import(/* webpackPrefetch: true, webpackChunkName: 'matches' */ 'wap/views/search/App.vue')

const parseEventId = (route) => {
  // 兼容旧的 query.e 参数类型，并兼容错误的拼接参数
  const eventId = (route.params.eventId || route.query.e).replace(/&(.+)?/, '')
  return decodeURIComponent(eventId)
}

const routesMatches = [
  // 比赛结果页
  {
    path: '/sports/result/:sportName/:category_name_tournament_name/:home_team_vs_away_team/:eventId?',
    name: 'matchResult',
    component: ResultDetail,
    meta: {
      title: 'Match Result | MSport',
      enableTheme: true
    },
    props: (route) => ({ eventId: parseEventId(route) })
  },

  // live 比赛列表页
  {
    path: '/sports/:sportName/live_matches',
    name: 'liveMatchList',
    component: LiveList,
    meta: {
      source: 'LiveList',
      requiresFirstNavs: true,
      requiresBetslip: true,
      title: 'Live Matches | Sports | MSport',
      enableTheme: true
    }
  },

  // match list
  {
    path: '/sports/list/:sportName?',
    alias: ['/sports/list/:sportName/matches_on_today', '/sports/list/:sportName/*'],
    name: 'matchList',
    component: MatchList,
    props: (route) => ({
      sportName: decodeURIComponent(route.params.sportName || 'Soccer')
    }),
    meta: {
      source: 'MatchList',
      requiresBetslip: true,
      enableTheme: true
    }
  },

  // live & prematch 比赛详情页
  {
    path: '/sports/:sportName/live/:category_name_tournament_name/:home_team_vs_away_team/:eventId?',
    alias: '/sports/:sportName/:category_name_tournament_name/:home_team_vs_away_team/:eventId?',
    name: 'matchDetail',
    component: MatchDetail,
    props: (route) => {
      return {
        eventId: parseEventId(route),
        tab: route.query.tab ? decodeURIComponent(route.query.tab) : '',
        group: route.query.group ? decodeURIComponent(route.query.group) : ''
      }
    },
    meta: {
      source: 'MatchDetail',
      requiresBetslip: true,
      enableTheme: true
    }
  },

  // sports
  {
    path: '/sports',
    alias: '/sports/index',
    name: 'Sports',
    component: Sports,
    meta: {
      requiresFirstNavs: true,
      title: 'Sports | MSport',
      enableTheme: true
    }
  },

  {
    path: '/find_matches',
    alias: '/search',
    name: 'search',
    component: Search,
    meta: {
      source: 'Search',
      hideHeader: true,
      title: 'Search | MSport'
    }
  }
]

export default routesMatches
